package com.karyadina.ui.util

import androidx.compose.runtime.Composable

@Composable
actual fun BackHandler(enabled: Boolean, onBack: () -> Unit) {
    // JS web usually relies on browser history. 
    // Implementing this fully would require History API integration.
    // No-op for now.
}
